import React from "react";

const Footer = () => {
  return (
    <footer className="bg-[#0d0d0d] backdrop-blur">
      <div className="mx-auto flex max-w-5xl items-center justify-center px-6 py-6">
        <p className="text-sm font-light text-neutral-500">
          &copy; 2026. All rights reserved.
        </p>

       
      </div>
    </footer>
  );
};

export default Footer;
